// extracted by mini-css-extract-plugin
export default {"element":"textElement_element__T4few","resize":"textElement_resize__PBkGc","textArea":"textElement_textArea__1jYNL"};